module.exports = __webpack_public_path__ + "img/bg_2.9eb8288f.jpg";